import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearAuthUser } from "../../../Redux/Slices/authSlice";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { apiUrl } from "../../../config";
import { fetchAllProduct } from "../../../service/ProductService";
import { fetchProductImage } from "../../../service/ProductImageService";
import { fetchCategory } from "../../../service/CategoryService";
import { getCartProductsByCustomerId } from "../../../service/CartService";
import { getWishlistProductsByCustomerId } from "../../../service/WishlistService";
import "../../../styles/topbar.css";
import { fetchGoldRate } from "../../../service/GoldRateService";

const Topbar = ({ flag }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [input, setInput] = useState("");
  const [products, setProducts] = useState([]);
  const [productImages, setProductImages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [list, setList] = useState([]);
  const [cartCount, setCartCount] = useState();
  const [wislistCount, setWishlistCount] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const authUser = useSelector((state) => state.auth.authUser);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [goldRate, setGoldRate] = useState(null);

  const fetchData = async () => {
    const productsData = await fetchAllProduct();
    setProducts(productsData);
    const productImagesData = await fetchProductImage();
    setProductImages(productImagesData);
    const categoriesData = await fetchCategory();
    setCategories(categoriesData);
  };

  useEffect(() => {
    return async () => {
      if (authUser?.id) {
        const cartProducts = await getCartProductsByCustomerId(authUser.id);
        setCartCount(cartProducts.length);
        const wishlistProducts = await getWishlistProductsByCustomerId(
          authUser.id,
        );
        setWishlistCount(wishlistProducts.length);
      }
    };
  });

  useEffect(() => {
    const goldRate = async () => {
      const rate = await fetchGoldRate();
      setGoldRate(rate[0]);
    };
    goldRate();
  }, []);

  //   useEffect(() => {
  //   const fetchCounts = async () => {
  //     if (authUser?.id) {
  //       const cartProducts = await getCartProductsByCustomerId(authUser.id);
  //       setCartCount(cartProducts.length);

  //       const wishlistProducts = await getWishlistProductsByCustomerId(authUser.id);
  //       setWishlistCount(wishlistProducts.length);
  //     }
  //   };

  //   fetchCounts();
  // }, [authUser]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onLogout = () => {
    dispatch(clearAuthUser());
    navigate("/login");
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setInput(value);

    if (value.trim() === "") {
      setList([]);
      return;
    }

    const data =
      products
        ?.filter(
          (d) => d.name && d.name.toLowerCase().startsWith(value.toLowerCase()),
        )
        ?.map((d) => {
          const img = productImages.find((img) => img.productId === d.id);
          return {
            type: "product",
            name: d.name,
            image: img ? img.imageUrl : null,
            id: d.id,
          };
        }) || [];

    const data2 =
      categories
        ?.filter(
          (d) => d.name && d.name.toLowerCase().startsWith(value.toLowerCase()),
        )
        ?.map((d) => ({
          type: "category",
          name: d.name,
          image: d.imageUrl || null,
          id: d.id,
        })) || [];

    setList([...data2, ...data]);
  };

  const getProductImageUrl = (productId) => {
    const img = productImages.find((img) => img.productId === productId);
    return img ? `${apiUrl}/${img.imageUrl}` : "assets/images/no-image.png";
  };

  const searchProduct = (item) => {
    if (item.type === "product") {
      window.location.href = `/${item.id}`;
    } else if (item.type === "category") {
      window.location.href = `/products?categoryId=${item.id}`;
    }
  };

  return (
    <>
      <div className="topbar-container">
        {goldRate && (
          <div className="gold-ticker">
            <div className="gold-ticker-track">
              {/* <span className="gold-date">
                {new Date().toLocaleDateString()}
              </span> */}
            </div>

            <div className="gold-ticker-content">
              <span className="gold-badge badge-22k">
                22K Gold : ₹{goldRate["r22kRate"]} /g
              </span>

              <span className="gold-badge badge-24k">
                24K Gold : ₹{goldRate["r24kRate"]} /g
              </span>
            </div>

          </div>
        )}
        <Container fluid className="topbar-main">
          <Row className="topbar-row">
            {/* ===== Logo ===== */}
            <Col
              lg="2"
              md="6"
              xs="auto"
              className="topbar-logo-col d-none d-lg-flex justify-content-center"
            >
              <div className="topbar-logo">
                <Link to="/">
                  <img src="/assets/images/logo-1.png" alt="logo" />
                </Link>
              </div>
            </Col>

            {/* ===== Desktop Search ===== */}
            <Col lg="4" md="5" className="topbar-search-col d-none d-lg-block">
              <div className="topbar-search-form">
                <form>
                  <div className="topbar-search-input-group">
                    <input
                      type="text"
                      value={input}
                      onChange={handleSearchChange}
                      placeholder="Search your product by category"
                      className="topbar-search-input"
                    />
                    <button
                      className="topbar-search-button"
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        if (list.length > 0) {
                          searchProduct(list[0]);
                        }
                      }}
                    >
                      <i className="ph ph-magnifying-glass" />
                    </button>
                  </div>
                  {list?.length > 0 && (
                    <ul className="topbar-search-results">
                      {list.map((item, index) => (
                        <li
                          key={index}
                          onClick={() => searchProduct(item)}
                          className="topbar-search-item"
                        >
                          <img
                            src={
                              item.image
                                ? apiUrl + "/" + item.image
                                : getProductImageUrl(item.id)
                            }
                            alt={item.name}
                          />
                          <span>
                            {item.type === "category"
                              ? item.name.charAt(0).toUpperCase() +
                                item.name.slice(1)
                              : item.name}
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                </form>
              </div>
            </Col>
            <Col lg="2"></Col>

            {/* <Col lg="2" className="d-none d-lg-flex">
              {goldRate && (
                <>
                  <div className="gold-rate-wrapper">
                    <div className="gold-box">
                      <h4 className="gold-title">22K</h4>
                      <h3 className="gold-price">₹{goldRate["r22kRate"]}/g</h3>
                    </div>

                    <div className="gold-box">
                      <h4 className="gold-title">24K</h4>
                      <h3 className="gold-price">₹{goldRate["r24kRate"]}/g</h3>
                    </div>
                  </div>
                </>
              )}
            </Col> */}

            {/* ===== Desktop Icons ===== */}
            <Col
              lg="3"
              md="6"
              className="topbar-nav d-none d-lg-flex justify-content-around"
            >
              <div className="d-flex align-items-center gap-5">
                {/* Wishlist */}
                <div className="topbar-nav-item">
                  <Link to="/wishlist" className="topbar-nav-icon">
                    <div style={{ position: "relative" }}>
                      <i className="ph ph-heart" />
                      <span className="topbar-badge">{wislistCount || 0}</span>
                    </div>
                    <p className="topbar-nav-icon-text">My Wishlist</p>
                  </Link>
                </div>

                {/* Cart */}
                <div className="topbar-nav-item">
                  <Link to="/shopping-cart" className="topbar-nav-icon">
                    <div style={{ position: "relative" }}>
                      <i className="ph ph-shopping-cart-simple" />
                      <span className="topbar-badge">{cartCount || 0}</span>
                    </div>
                    <p className="topbar-nav-icon-text">My Cart</p>
                  </Link>
                </div>

                {/* Orders */}
                <div className="topbar-nav-item">
                  <Link to="/my-orders" className="topbar-nav-icon ">
                    <i className="ph ph-package mb-4" />
                    <p className="topbar-nav-icon-text">My Orders</p>
                  </Link>
                </div>

                {/* Profile / Logout */}
                <div className="topbar-nav-item">
                  {!flag ? (
                    <Link
                      to={authUser === null ? "/login" : "/profile"}
                      className="topbar-nav-icon"
                    >
                      <i className="ph ph-user mb-4" />
                      <p className="topbar-nav-icon-text">
                        {authUser === null ? "login" : "profile"}
                      </p>
                    </Link>
                  ) : (
                    <div
                      className="topbar-nav-icon"
                      onClick={onLogout}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="ph ph-sign-out mb-4" />
                      <p className="topbar-nav-icon-text">Logout</p>
                    </div>
                  )}
                </div>
              </div>
            </Col>
            <Col xs={12} className="d-lg-none mt-2">
              {/* Top Row: Hamburger + Logo + Icons */}
              <div className="mobile-icons-row d-flex align-item-center position-relative mb-3">
                {/* Hamburger */}
                <div
                  className="mobile-hamburger position-absolute start-0 ms-3"
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                  <i className="ph ph-list"></i>
                </div>

                {/* Logo */}
                <div className="topbar-logo mx-auto ms-5 ">
                  <Link to="/">
                    <img src="/assets/images/logo-1.png" alt="logo" />
                  </Link>
                </div>
              </div>
              <div className="d-flex justify-content-evenly align-items-center gap-3 mb-4">
                <Link
                  to="/wishlist"
                  className="topbar-nav-icon"
                  style={{ position: "relative" }}
                >
                  <i className="ph ph-heart" />
                  <span className="topbar-badge">{wislistCount || 0}</span>
                </Link>
                <Link
                  to="/shopping-cart"
                  className="topbar-nav-icon"
                  style={{ position: "relative" }}
                >
                  <i className="ph ph-shopping-cart-simple" />
                  <span className="topbar-badge">{cartCount || 0}</span>
                </Link>
                <Link to="/my-orders" className="topbar-nav-icon">
                  <i className="ph ph-package" />
                </Link>
                {!flag ? (
                  <Link
                    to={authUser === null ? "/login" : "/profile"}
                    className="topbar-nav-icon"
                  >
                    <i className="ph ph-user" />
                  </Link>
                ) : (
                  <div
                    className="topbar-nav-icon"
                    onClick={onLogout}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="ph ph-sign-out" />
                  </div>
                )}
              </div>

              {/* Bottom Row: Full-width Search */}
              <div className="mobile-search-full d-flex align-item-center ">
                <div className="topbar-search-form">
                  <form>
                    <div className="topbar-search-input-group">
                      <input
                        type="text"
                        value={input}
                        onChange={handleSearchChange}
                        placeholder="Search your product by category"
                        className="topbar-search-input"
                      />
                      <button
                        className="topbar-search-button"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          if (list.length > 0) {
                            searchProduct(list[0]);
                          }
                        }}
                      >
                        <i className="ph ph-magnifying-glass" />
                      </button>
                    </div>
                    {list?.length > 0 && (
                      <ul className="topbar-search-results">
                        {list.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => searchProduct(item)}
                            className="topbar-search-item"
                          >
                            <img
                              src={
                                item.image
                                  ? apiUrl + "/" + item.image
                                  : "/assets/images/no-img.png"
                              }
                              alt={item.name}
                            />
                            <span>{item.name}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </form>
                </div>
              </div>
              {/* <div>
                {goldRate && (
                  <>
                    <div className="gold-rate-wrapper">
                      <div className="gold-box">
                        <h4 className="gold-title">22K</h4>
                        <h3 className="gold-price">
                          ₹{goldRate["r22kRate"]}/g
                        </h3>
                      </div>

                      <div className="gold-box">
                        <h4 className="gold-title">24K</h4>
                        <h3 className="gold-price">
                          ₹{goldRate["r24kRate"]}/g
                        </h3>
                      </div>
                    </div>
                  </>
                )}
              </div> */}
            </Col>
          </Row>
        </Container>

        <div className="topbar-sticky-menu  d-none d-lg-flex">
          {/* Main menu */}
          <div className="topbar-main-menu">
            <Link to="/" className="topbar-main-menu-link">
              Home
            </Link>
            
              {categories.map((cat) => (
               
                  <Link
                   key={cat.id}
                    to={`/products?categoryId=${cat.id}`}
                    className="topbar-main-menu-link"
                  >
                    {cat.name}
                  </Link>
              ))}
            <Link to="/about-us" className="topbar-main-menu-link">
              About Us
            </Link>
            <Link to="/contact-us" className="topbar-main-menu-link">
              Contact Us
            </Link>

          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="mobile-dropdown-top bg-white shadow-sm p-3">
            {/* Other Links */}
            <ul className="mobile-dropdown-list list-unstyled m-0">
              <li>
                <Link to="/" onClick={() => setMobileMenuOpen(false)}>
                  Home
                </Link>
              </li>
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/products?categoryId=${cat.id}`}
                    onClick={() => setMobileMenuOpen(false)}
                    style={{
                      textDecoration: "none",
                      color: "black",
                      textTransform: "capitalize",
                    }}
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/about-us" onClick={() => setMobileMenuOpen(false)}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact-us" onClick={() => setMobileMenuOpen(false)}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        )}
      </div>
    </>
  );
};

export default Topbar;
